<template>
    <div class="business">
        <banner img="../assets/img/bgtop.jpg" title="承接业务" />
        <div class="business-content">
            <ul class="case-item">
                <li
                    v-for="(cas, index) in caseList"
                    :key="index"
                    v-lazy:background-image="cas.filePath"
                > 
                    <router-link
                    class="text-decoration"
                    :to="{ name: 'Tabe', query: { id: cas.id } }"
                    >
                    <div class="case-item-hover">
                        <p class="hover-title">{{ cas.name }}</p>
                        <div class="description">{{ cas.description }}</div>
                        <div class="more">
                        <span>MORE</span>
                        </div>
                    </div>
                    </router-link>
                <p class="item-list-title" @click="routeLink(item.id)">{{ cas.name }}</p>
                </li>
            </ul>
        </div>
        
    </div>
    
  </template>
  
  <script>
  import Banner from "../components/Banner";
  export default {
    components: {
        Banner
    },
    name: 'BusinessList',
    data() {
      return {
        caseList: [],
        loading:true
      };
    },
    methods:{
        getLoadData(){
            this.$http
            .get(`business/list`)
            .then(response => {
                this.caseList = response.data.data;
                for (let obj of this.caseList) {
                    obj.filePath = this.imgserver + obj.filePath;
                }
                console.log(this.caseList)
                // 设置第一个内容的图片和描述
                this.loading = false;
            })
                .catch(function (error) {
                window.console.log(error);
            });
        }
    },
    mounted(){
      this.getLoadData()
    }
  };
  </script>


<style scoped lang="scss">

.business {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-content{
    user-select: none;
    width: 80vw;
    margin: 0 auto;
    padding: 3vw;
    background-color: var(--global-content-background-color);
    min-height: 35vw;
    position: relative;
    z-index: 1!important;
    .case-item {
        width: 80vw; /* 调整宽度 */
        max-width: 1200px; /* 最大宽度限制 */
        height: auto; /* 自适应高度 */
        margin: 0 auto;
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap; /* 允许换行 */
        justify-content: center; /* 水平居中 */

    li {
        width: 30%; /* 设置宽度为 30% 以便一行显示 3 个 */
        max-width: 350px; /* 最大宽度限制 */
        height: 20vw; /* 增加高度 */
        list-style: none;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        margin: 15px; /* 设置间距 */
        position: relative;
        overflow: hidden;
        border-radius: 10px; /* 圆角 */
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* 阴影效果 */
        transition: transform 0.3s ease; /* 过渡效果 */
        display: flex;
        justify-content: center;
        align-items: center;

        .item-list-title{
            width: 100%;
            text-align: center;
            color: rgb(249, 251, 251,0.9);;
            display: block;
            font-size: 2.5vw;
            letter-spacing: 0.5rem;
        }

        &:hover {
        transform: scale(1.05); /* 悬停时放大效果 */
        .item-list-title{
            display: none;
        }
        .case-item-hover {
            opacity: 1;
            transition: all 0.4s ease-in-out;
        }
        }
    }
    }

    .case-item-hover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.7); /* 更深的背景色 */
    display: flex;
    flex-direction: column; // 垂直排列
    justify-content: center; // 垂直居中
    align-items: center; // 水平居中
    text-align: center; // 文本居中
    transition: opacity 0.3s ease; /* 过渡效果 */

    .hover-title {
        color: #fff;
        font-size: 26px; // 增大字体
        font-weight: bold; // 加粗字体
        margin: 20px 0; // 上下间距
        font-family: 'Courier New', Courier, monospace;
    }

    .description {
        width: 90%;
        color: #fff;
        font-size: 16px; // 描述文本的字体大小
        margin: 10px 20px; // 上下间距，左右间距
        line-height: 1.5; // 行高
        padding: 1vw 0vw;
        max-height: 100px; // 限制最大高度
        overflow: hidden; // 超出部分隐藏
        text-overflow: ellipsis; // 溢出文本省略号
        white-space: nowrap; // 不换行
    }

    .bottom {
        border-bottom: 1px solid #fff;
        width: 100%;
        height: auto; // 让高度自适应
        margin: 0 auto;
        display: -webkit-box; // 使用 flexbox
        overflow: hidden; // 隐藏超出部分
        -webkit-line-clamp: 3; // 限制行数为 3 行
        -webkit-box-orient: vertical; // 垂直排列
        text-overflow: ellipsis; // 溢出文本省略号
        font-size: 1vw; // 字体大小
        line-height: 1.2; // 行高，确保行间距合适
        padding: 0vw 1vw;
        box-sizing: border-box;
        color: #e4e7ed;
        font-family: 'Courier New', Courier, monospace;
    }

    .more {
        width: 90px;
        padding: 5px 5px;
        margin-top: 20px; /* 调整顶部间距 */
        border: 2px solid #fff;
        border-radius: 5px; /* 圆角边框 */
        background-color: rgba(255, 255, 255, 0.2); /* 背景色 */
        transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; /* 过渡效果 */

        &:hover {
            background-color: rgba(255, 255, 255, 0.5); /* 悬停时的背景色 */
            transform: scale(1.05); /* 悬停时放大效果 */
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3); /* 悬停时的阴影效果 */
        }

        span {
            color: #fff;
            font-size: 20px;
        }
    }
    }
  }


}
</style>